import { queryOptions, useQuery, useSuspenseQuery } from '@tanstack/react-query'
import { getAllRoles, getMyActualRoles, getRolesForStaff } from './api'

export const staffRolesQueryOptions = () =>
    queryOptions({
        queryKey: ['staffRoles'],
        queryFn: () => getAllRoles(),
    })

export function useStaffRoles() {
    return useQuery(staffRolesQueryOptions())
}

export function useStaffRolesSuspense() {
    return useSuspenseQuery(staffRolesQueryOptions())
}

export const actualStaffRolesQueryOptions = () =>
    queryOptions({
        queryKey: ['actualStaffRoles'],
        queryFn: () => getMyActualRoles(),
    })

export function useActualStaffRoles() {
    return useQuery(actualStaffRolesQueryOptions())
}

export function useActualStaffRolesSuspense() {
    return useSuspenseQuery(actualStaffRolesQueryOptions())
}

export const userRolesForStaffQueryOptions = (initials: string) =>
    queryOptions({
        queryKey: ['userRolesForStaff', initials],
        queryFn: () => getRolesForStaff(initials),
    })

export function useUserRolesForStaff(initials: string) {
    return useQuery(userRolesForStaffQueryOptions(initials))
}

export function useUserRolesForStaffSuspense(initials: string) {
    return useSuspenseQuery(userRolesForStaffQueryOptions(initials))
}